import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesTraspasos() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Movimientos", items: [
      { label: "Traspasos Salida", icon: "fas fa-sign-out-alt", color: "#f59e0b", href: "/ListadoTraspasosSalida", desc: "Salida de mercancia", enabled: !!user.menu_traspasos_salida },
      { label: "Traspasos Entrada", icon: "fas fa-sign-in-alt", color: "#10b981", href: "/ListadoTraspasosEntrada", desc: "Entrada de mercancia", enabled: !!user.menu_traspasos_entrada },
    ]},
    { section: "Cobranza", items: [
      { label: "Abonos", icon: "fas fa-dollar-sign", color: "#06b6d4", href: "/ListadoAbonosTraspasos", desc: "Abonos de traspasos", enabled: !!user.abonos },
      { label: "Estado Cuenta", icon: "fas fa-file-invoice-dollar", color: "#6366f1", href: "/EstadoCuentaTraspasos", desc: "Estado de cuenta", enabled: !!user.edoCtaClientes },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Traspasos"
      descripcion="Entradas, salidas y cobranza de traspasos"
      icono="fas fa-exchange-alt"
      color="#f59e0b"
      secciones={SECCIONES}
    />
  );
}

export default BotonesTraspasos;
